import React from 'react';
import { MdPlace, MdPhone, MdLanguage, MdCode } from 'react-icons/md';
import { FaWhatsapp, FaFacebookF, FaInstagram } from 'react-icons/fa';
import { SCHOOL_INFO, DEVELOPER, RIGHTS } from './about';

function Link({ href, icon: Icon, children, ltr }) {
  return (
    <a className="ab-link" href={href} target={href.startsWith('tel:') ? undefined : '_blank'} rel="noopener noreferrer">
      <Icon />
      <span dir={ltr ? 'ltr' : undefined}>{children}</span>
    </a>
  );
}

/** The school card + developer credit + rights, at the foot of الملف. */
export default function AboutSchool() {
  return (
    <section className="ab-box">
      <div className="ab-school">
        <img src={SCHOOL_INFO.logo} alt={`شعار ${SCHOOL_INFO.name}`} className="ab-logo" />
        <div>
          <strong>{SCHOOL_INFO.name}</strong>
          <p><MdPlace /> {SCHOOL_INFO.address}</p>
        </div>
      </div>
      <div className="ab-links">
        <Link href={`tel:${SCHOOL_INFO.phones[0].tel}`} icon={MdPhone} ltr>{SCHOOL_INFO.phones[0].label}</Link>
        <Link href={SCHOOL_INFO.whatsapp} icon={FaWhatsapp}>واتساب</Link>
        <Link href={SCHOOL_INFO.facebook} icon={FaFacebookF}>فيسبوك</Link>
        <Link href={SCHOOL_INFO.instagram} icon={FaInstagram}>إنستغرام</Link>
        <Link href={SCHOOL_INFO.website} icon={MdLanguage} ltr>mtzedu.com</Link>
      </div>

      <div className="ab-dev">
        <MdCode />
        <span>{DEVELOPER.role}: </span>
        <a href={DEVELOPER.website} target="_blank" rel="noopener noreferrer"><strong>{DEVELOPER.name}</strong></a>
        <span className="ab-dev-links">
          <a href={DEVELOPER.website} target="_blank" rel="noopener noreferrer" dir="ltr">{DEVELOPER.websiteLabel}</a>
          <a href={`tel:${DEVELOPER.phone.tel}`} dir="ltr">{DEVELOPER.phone.label}</a>
        </span>
      </div>

      <div className="ab-rights">
        <p>{RIGHTS.school}</p>
        <p>{RIGHTS.developer}</p>
        <p>{RIGHTS.noCopy}</p>
      </div>
    </section>
  );
}
